<template>
  <div class="component-integration-card h-100">
    <div class="integration-card">
      <div class="d-flex gap-3">
        <div class="d-flex align-items-start mb-3">
          <img :src="image" alt="integração" />
        </div>

        <div class="d-flex flex-column align-items-start">
          <h5 class="text-semibold">{{ integration.title }}</h5>
          <h5 v-if="integration.description" class="text-dark-40">
            {{ integration.description }}
          </h5>
          <div v-if="$slots['extra-buttons']">
            <slot name="extra-buttons" />
          </div>
        </div>
      </div>

      <div
        v-if="integration.modal"
        class="d-flex justify-content-end gap-2 mt-1"
      >
        <snow-button
          size="sm"
          text="Integrar"
          class="order-0 order-lg-1"
          @click="integrate"
        />

        <snow-button
          size="sm"
          variant="gray"
          text="Visualizar"
          @click="goToIntegration"
        />
      </div>

      <div v-else class="text-right text-dark-40 fs-12">
        Em breve
      </div>
    </div>
    <responsive-modal
      v-if="newModal"
      v-model="modal"
      :title="`Integrar ${integration.title}`"
    >
      <a
        :href="integration.link"
        v-if="integration.link"
        target="_blank"
        class="integration-link mb-4"
      >
        Conheça a {{ integration.title }}
        <i class="ph ph-arrow-square-out" />
      </a>
      <component
        class="integration-modal"
        :is="integration.modal"
        @close="modal = false"
      />
    </responsive-modal>
    <component
      v-else
      v-model="modal"
      class="integration-modal"
      :is="integration.modal"
      @close="modal = false"
    />
  </div>
</template>
<script>
import slugify from "slugify";
export default {
  data() {
    return {
      modal: false
    };
  },
  props: {
    integration: {
      type: Object,
      default: () => ({})
    },
    newModal: Boolean
  },
  methods: {
    goToIntegration() {
      this.$router.push({
        name: `tools-${slugify(this.integration.title.toLowerCase())}`
      });
    },
    integrate() {
      this.$store.commit("integration/setIntegration", this.integration.name);
      this.modal = true;
    }
  },
  computed: {
    image() {
      return (
        this.integration.image ||
        require("@/assets/images/integrations/integration-placeholder.svg")
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.integration-card {
  height: 100%;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid var(--dark-10);
  background: var(--bg-5);
  img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
}
</style>
